import { Injectable } from "@angular/core";

// Converts any random string to a color from the Airbrake palette.
@Injectable()
export class StringToColorService {
  private COLORS = [
    "red-400",
    "green-500",
    "orange-500",
    "blue-100",
    "blue-200",
    "blue-400",
    "blue-300",
    "blue-600",
    "blue-700",
    "green-600",
    "green-200",
    "green-400",
    "green-700",
    "orange-400",
    "orange-600",
    "orange-300",
    "orange-200",
    "red-700",
    "grey-600",
  ];

  private colorLen = this.COLORS.length;

  public colorFor(s: string) {
    return this.COLORS[this.hashCode(s) % this.colorLen];
  }

  private hashCode(s: string) {
    const reducer = (hash: number, str: string) => {
      /* tslint:disable:no-bitwise */
      hash = (hash << 5) - hash + str.charCodeAt(0);
      return hash & hash;
      /* tslint:enable:no-bitwise */
    };

    return Math.abs(s.toString().split("").reduce(reducer, 0));
  }
}
